import React from "react";
import PropTypes from "prop-types";

const Image = ({className, image }) => {
  return (
    <>
     <img src={image} className={className} alt="" />
    </>
  );
};

Image.prototypes = {
  className : PropTypes.string,
  image: PropTypes.string.isRequired,
};

export default Image;
